import React, { useEffect, useState } from "react"
import { Divider, ListSubheader, MenuItem } from "@material-ui/core"
import { OutlinedSelect } from "../OutlinedSelect"
import { IntegrationLocationConfiguration } from "./IntegrationLocationConfiguration"
import { IntegrationLocationGroupConfiguration } from "./IntegrationLocationGroupConfiguration"
import { IntegrationEventsConfiguration } from "./IntegrationEventsConfiguration"
import { IntegrationUserConfiguration } from "./IntegrationUserConfiguration"

const IntegrationConfiguration = ({ integration }) => {
  const [area, setArea] = useState("events")
  const [hasLocation, setHasLocation] = useState(false)
  const [hasLocationGroup, setHasLocationGroup] = useState(false)
  const [hasUser, setHasUser] = useState(false)

  const {
    integrationProvider: { attributes },
  } = integration

  useEffect(() => {
    setHasLocation(Boolean(attributes?.location.length))
    setHasLocationGroup(Boolean(attributes?.locationGroup.length))
    setHasUser(Boolean(attributes?.user.length))
  }, [attributes])

  const handleChange = (event) => {
    setArea(event.target.value)
  }

  const hasSelect = hasLocation || hasUser

  return (
    <>
      {hasSelect && (
        <OutlinedSelect label="Configure" value={area} native={false} onChange={handleChange}>
          <MenuItem value="events">Events</MenuItem>
          {hasLocation && <Divider />}
          {hasLocation && <ListSubheader disableSticky>Location mappings</ListSubheader>}
          {hasLocation && <MenuItem value="location">All locations</MenuItem>}
          {hasLocation && <MenuItem value="location-unmapped">Unmapped locations</MenuItem>}
          {hasLocationGroup && <Divider />}
          {hasLocationGroup && <ListSubheader disableSticky>Area of Work mappings</ListSubheader>}
          {hasLocationGroup && <MenuItem value="locationgroup">All areas of work</MenuItem>}
          {hasUser && <Divider />}
          {hasUser && <ListSubheader disableSticky>User mappings</ListSubheader>}
          {hasUser && <MenuItem value="user">All users</MenuItem>}
          {hasUser && <MenuItem value="user-unmapped">Unmapped users</MenuItem>}
        </OutlinedSelect>
      )}

      {area === "events" && <IntegrationEventsConfiguration integration={integration} hasTitle={!hasSelect} />}
      {area === "location" && hasLocation && <IntegrationLocationConfiguration area={area} integration={integration} />}
      {area === "location-unmapped" && hasLocation && (
        <IntegrationLocationConfiguration area={area} integration={integration} />
      )}
      {area === "locationgroup" && hasLocationGroup && (
        <IntegrationLocationGroupConfiguration area={area} integration={integration} />
      )}
      {area === "user" && hasUser && <IntegrationUserConfiguration area={area} integration={integration} />}
      {area === "user-unmapped" && hasUser && <IntegrationUserConfiguration area={area} integration={integration} />}
    </>
  )
}

export { IntegrationConfiguration }
